import { Controller } from 'stimulus'

export default class extends Controller {
  connect () {
    this.isOpen = false
  }

  clickOutsideHandler (e) {
    if (this.isOpen && !this.element.contains(e.target)) {
      this.element.classList.remove("active")
      this.isOpen = false
    }
  }

  toggleActive (event) {
    event.preventDefault()
    this.element.classList.toggle("active", !this.isOpen)
    this.isOpen = !this.isOpen
  }
}
